import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { Redirect } from 'react-router-dom';

class Logout extends Component {
	render() {
		return <Redirect to="/" />;
	}

	componentDidMount() {
		// We implement this logic inside the componentDidMount beacuse render method is supposed to be
		// a pure function which should not modify the state and props
		this.props.onLogout();
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onLogout: () => dispatch(actions.logout()),
	};
};

export default connect(null, mapDispatchToProps)(Logout);
